'use client';

import { IconChevronRight } from '@repo/svgs';
import { cn } from '@/lib/cn';
import { ModalTrigger } from '@/components/ui/ModalTrigger';
import dynamic from 'next/dynamic';
import { useBuilding } from '../../context/BuildingProvider';
import { useAnalytics } from '@/hooks/useAnalytics';

const AlternativeAddressesModal = dynamic(() =>
  import('./modals/AlternativeAddressesModal').then(mod => mod.AlternativeAddressesModal),
);

export function AlternativeAddressesTrigger() {
  const { buildingAddresses, building } = useBuilding();
  const analytics = useAnalytics();
  if (!buildingAddresses || buildingAddresses.length === 0) return null;

  return (
    <>
      {/*
       * The aliases as real text in the document, clipped from view.
       *
       * This is the point of the change: the popup alone is invisible to a
       * crawler, which executes JS but never clicks. Handing the array to the
       * provider only puts it in the hydration payload, which is not read as
       * page content — it has to be printed as markup to count.
       *
       * `sr-only` clips rather than removing from the layout; `display: none`
       * would be crawled but discounted. The primary address stays the title,
       * H1, breadcrumb endpoint, canonical and principal schema address —
       * these are additional signals, not a replacement.
       */}
      <ul className="sr-only" aria-label="All registered addresses for this building">
        {buildingAddresses.map(address => (
          <li key={address.id}>{address.fullAddress || address.streetAddress}</li>
        ))}
      </ul>

      <ModalTrigger
        label="Alternative addresses"
        content={<AlternativeAddressesModal />}
        urlKey="alternative-addresses"
      >
        <button
          className={cn('flex items-center gap-1 py-2', 'text-body-2-high text-accent')}
          onClick={() => {
            analytics.track('building_alternative_address', {
              buildingId: building.id,
              addressSlug: building.slug,
            });
          }}
        >
          <span>View alternative addresses</span>
          <IconChevronRight className="w-3 h-3" />
        </button>
      </ModalTrigger>
    </>
  );
}
